import { CSSObject, MantineTheme } from '@mantine/core'

const boxSx = (theme: MantineTheme): CSSObject => ({
  boxShadow: theme.shadows.md,
  backgroundColor:
    theme.colorScheme === 'dark'
      ? theme.fn.rgba(theme.colors.dark[7], 0.3)
      : theme.fn.rgba(theme.colors.dark[0], 0.3),
  borderRadius: theme.radius.md,
  margin: theme.spacing.sm,
  padding: theme.spacing.sm,
  minWidth: '300px',
})

export default boxSx
